import { IconProps } from "./types";

/** Used by EmptyState — generic "nothing here" illustration. */
export const InboxIcon = ({ size = 32, color = "currentColor", className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path d="M4 12.5 6.5 5h11l2.5 7.5" stroke={color} strokeWidth={1.6} strokeLinejoin="round" />
    <path
      d="M4 12.5h5.2c.4 1.2 1.4 2 2.8 2s2.4-.8 2.8-2H20V18a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18v-5.5Z"
      stroke={color}
      strokeWidth={1.6}
      strokeLinejoin="round"
    />
  </svg>
);
